import { Button } from "@/components/ui/button";
import { motion } from "motion/react";
import Link from "next/link";
import { AnimatedItem } from "../../../../components/ui/animated-item";
import { LottieVisible } from "../../../../components/ui/lottie-visible";

import type { JSX } from "react";

export function SignUpSection(): JSX.Element {
    return (
        <section className="flex flex-col items-start justify-center px-4 md:flex-row md:items-center md:py-32">
            <div className="m-8 flex basis-1/2 items-center justify-center self-center">
                <motion.div initial="inactive" whileInView="active" viewport={{ amount: 0.5, once: true }}>
                    <AnimatedItem style={{ width: 80, height: 160, margin: "96px 0" }}>
                        <LottieVisible src="/lottie/Main_Logo.json" loop />
                    </AnimatedItem>
                </motion.div>
            </div>
            <div className="flex basis-1/2 flex-col items-start">
                <motion.div initial="inactive" whileInView="active" viewport={{ amount: 0.8, once: true }}>
                    <AnimatedItem delay={0.2}>
                        <p className="w-fit rounded-full border border-border px-4 py-1.5">Talentir Agency Solution</p>
                    </AnimatedItem>
                    <AnimatedItem delay={0.4}>
                        <h2 className="my-6 text-balance font-bold text-4xl leading-tight md:text-5xl">
                            Scale Your Creator <span className="text-accent-flashy">Payouts</span>
                        </h2>
                        <p className="my-6 text-muted-foreground">
                            Talentir transparently, securely, and fully automates complex campaign payouts and takes
                            care of the entire accounting for you and your clients.
                        </p>
                    </AnimatedItem>
                    <AnimatedItem delay={0.6} className="mt-8">
                        <Button asChild>
                            <Link href="https://calendly.com/talentir/" target="_blank">
                                Meet the Founders
                            </Link>
                        </Button>
                    </AnimatedItem>
                </motion.div>
            </div>
        </section>
    );
}
